import React, { useEffect, useState } from "react";
import DealerService from "../../service/DealerService";
import dateformat from 'dateformat';

const ModalTransactionDetails = ({ data, userRole }) => {
    const [skuTYpes, setSkuTypes] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [skuSubsciptionTypes, setSkuSubscriptionTypes] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [skuListingTypes, setSkuListingTypes] = useState([]);
    
    useEffect(() => {
        fetchSkuTypes();
        fetchSkuListinTypes();
    }, [data]);


    const capitalizeFirst = (str) => {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    const fetchSkuTypes = async () => {
        try {
            const response = await DealerService.getMasters(["dealer_sku"]);
            if (response.status === 200 && response.data.status === 200) {
                let responsedata = response.data.data || {};
                if (responsedata.dealer_sku && responsedata.dealer_sku.length) {
                    let subscM = [], skuM = [];
                    // eslint-disable-next-line array-callback-return
                    responsedata.dealer_sku.map(v => {
                        if (v.sku_type === "subscription") subscM.push(v);
                        if (v.sku_type === "service") {
                            skuM.push({
                                value: v.id,
                                label: v.sku_name,
                            });
                        };
                    });

                    setSkuTypes(skuM);
                    setSkuSubscriptionTypes(subscM);
                }
            }
        } catch (error) {

        } finally {

        }
    };

    const fetchSkuListinTypes = async () => {
        try {
            const listingTypeResponse = await DealerService.getSkuListingTypes();
            
            if (listingTypeResponse.status === 200 && listingTypeResponse.data.status === 200) {
                let responsedata = listingTypeResponse.data.data || [];

                const mappedListing = responsedata.map((lType) => ({
                    value: lType?.id,
                    label: lType?.attribute_value
                }));

                setSkuListingTypes(mappedListing);
            }
        } catch (error) {
            console.error('error==========>', error);
        }
    };

    return (
        <div className='d-flex modal-transaction-inner'>
            <div className='transaction-left'>
                <table>
                    <tbody>
                        <tr>
                            <td>ID</td>
                            <td><span className='f-semibold'>{data?.id}</span></td>
                        </tr>
                        <tr>
                            <td>Package Name</td>
                            <td><span className='f-semibold'>{data?.package?.name}</span></td>
                        </tr>
                        <tr>
                            <td>Quota</td>
                            <td><span className='f-semibold'>{data?.package?.quota}</span></td>
                        </tr>
                        <tr>
                            <td>Total Leads</td>
                            <td><span className='f-semibold'>{data?.package?.total_leads}</span></td>
                        </tr>
                        <tr>
                            <td>Active Period</td>
                            <td><span className='f-semibold'>{`${data?.package?.active_period_days} Days`}</span></td>
                        </tr>
                        <tr>
                            <td>SKU Type</td>
                            <td><span className='f-semibold'>
                                {skuTYpes && skuTYpes?.length > 0 ? skuTYpes.find((t) => +t.value === +data?.package?.sku_type)?.label || data?.package?.sku_type : data?.package?.sku_type}
                            </span></td>
                        </tr>
                        <tr>
                            <td>Price</td>
                            <td><span className='f-semibold'>{data?.package?.price}</span></td>
                        </tr>
                        <tr>
                            <td>VAT (Already included in the Price)</td>
                            <td><span className='f-semibold'>{data?.package?.vat}</span></td>
                        </tr>
                        <tr>
                            <td>Discount</td>
                            <td><span className='f-semibold'>{data?.package?.discount_to_be_shown}</span></td>
                        </tr>
                        <tr>
                            <td>Additional Discount</td>
                            <td><span className='f-semibold'>{data?.additional_discount}</span></td>
                        </tr>
                        <tr>
                            <td>Net Price</td>
                            <td><span className='f-semibold'>{data?.amount}</span></td>
                        </tr>
                        <tr>
                            <td>Date</td>
                            <td><span className='f-semibold'>{data?.payment_status === 'success' && data?.payment_date ? dateformat(data?.payment_date, "yyyy-mm-dd HH:MM:ss") : data?.created_at ? dateformat(data?.created_at, "yyyy-mm-dd HH:MM:ss") : '-'}</span></td>
                        </tr>

                        {['admin'].includes(userRole) && (
                            <>
                                <tr>
                                    <td>Dealer ID</td>
                                    <td><span className='f-semibold'>{data?.dealer?.id ? `GCD${data?.dealer?.id}` : '-'}</span></td>
                                </tr>
                                <tr>
                                    <td>Dealer Name</td>
                                    <td><span className='f-semibold'>{data?.dealer?.organization ? `${data?.dealer?.organization}` : '-'}</span></td>
                                </tr>
                                <tr>
                                    <td>Dealer Email</td>
                                    <td><span className='f-semibold'>{data?.dealer?.dealership_email ? `${data?.dealer?.dealership_email}` : '-'}</span></td>
                                </tr>
                                <tr>
                                    <td>Dealer Phone</td>
                                    <td><span className='f-semibold'>{data?.dealer?.dealership_contact ? `${data?.dealer?.dealership_contact}` : '-'}</span></td>
                                </tr>
                            </>
                        )}

                        <tr>
                            <td>Transaction Status</td>
                            <td><span className='f-semibold'>{capitalizeFirst(data?.payment_status)}</span></td>
                        </tr>
                        <tr>
                            <td>Response</td>
                            <td><span className='f-semibold'>{data?.payment_status === 'success' ? `200. Payment Successfull` : data?.payment_status}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {data?.payment_mode !== 'Xendit' && <div className='payment-proof-box'>
                <span className='f-semibold block m-md-b'>Payment Proof</span>
                <div className='proof-img'>
                    {/* <img src="/img/payments/payment-receipt.jpg" alt=""/> */}
                    {data?.signed_payment_proof_url && (
                        <img src={data.signed_payment_proof_url} alt="Signed Payment Proof" />
                    )}
                </div>
            </div>}
        </div>
    );
};

export default ModalTransactionDetails;
